export const GRAPHQL_VARIABLES = {
  company: '5fbdb1a50c228f35dd575a37'
};

export const QUERY = `
  mutation acceptInvitation($company: MongoID!){
    acceptInvitation(company: $company){
        message
    }
}
`;
